export default __webpack_public_path__ + "assets/icon-point-of-sale-selected.9ab1a90c.webp";